import { Property } from "@flatfile/api/api";
import { FFValidator } from "src/utils";
import { INTEGER_VALIDATOR } from "./Validators";

export const OneTimeBonusFields: Property[] = [
  {
    label: "One-Time Bonus ($)",
    key: "oneTimeBonus",
    type: "number",
  },
  {
    label: "One-Time Bonus Notes",
    key: "oneTimeBonusNotes",
    type: "string",
  },
];

export const getOneTimeBonusValidators = () => [
  FFValidator.regexMatches(
    "oneTimeBonus",
    RegExp(INTEGER_VALIDATOR),
    "Must be a whole number"
  ),
];
